import {
  BookingStatus,
  enumBookingStatus,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingRevertStatusAtom = createMutationAtomFactory(
  'trade.bookingRevertStatus',
  (params: { id: string; previousStatus: BookingStatus }) => ({
    tradeBookingUpdate: {
      __args: {
        id: params.id,
        input: {
          status: params.previousStatus || enumBookingStatus.Draft,
        },
      },
      id: true,
      status: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
